<template>
  <div class="work-page">
    <v-card elevation="0">
      <v-card-text class="pa-0">
        <!-- <v-tabs
          v-model="tabMenu"
          style="border-bottom: 1px solid #184966"
          color="#184966"
          show-arrows
          grow
          :center-active="$vuetify.breakpoint.smAndDown"
        >
          <v-tab
            v-for="(tab, i) in countItemInTab(tab_list)"
            :key="tab.text"
            @click="setStatusShow(tab.value, i, tab.business_account_model)"
            v-show="tab.count > 0"
          >
            <span style="font-weight: 700" class="pr-2">
              {{ tab.text }}
            </span>
          </v-tab>
        </v-tabs> -->
        <v-tabs-items v-model="tabMenu">
          <!-- <v-tab-item v-for="i in tab_list.length" :key="i"  class="mt-5 px-5"> -->
          <v-tab-item v-for="i in tab_list.length" :key="i">
            <!-- <v-row no-gutters class="pb-4">
              <v-col cols="auto" align-self="center">ธุรกิจ</v-col>
              <v-col class="pl-3 pl-sm-5">
                <v-select
                  v-model="business_id"
                  :items="business_data_list_to_select"
                  placeholder="เลือกธุรกิจ"
                  item-text="business_name_th"
                  item-value="business_id"
                  dense
                  hide-details
                  outlined
                  @change="changeBusiness"
                >
                </v-select>
              </v-col>
            </v-row> -->
            <v-row
              v-if="business_profile[0] && show_trust_level == tabMenu"
              no-gutters
              class="text-center text-sm-start"
            >
              <v-col
                cols="12"
                sm="auto"
                v-if="$route.name == 'Work' && applicant_apply_data"
                style="text-align: center"
                align-self="center"
              >
                <!-- change theme -->
                <v-chip
                  outlined
                  class="my-4 my-sm-0 ml-sm-3"
                  color="default_chip_primary"
                >
                  จำนวนคนที่สมัคร {{ applicant_apply_data.applicant_total }} คน
                </v-chip>
                <v-chip
                  outlined
                  class="my-4 my-sm-0 ml-sm-3"
                  color="default_chip_primary"
                >
                  จำนวนครั้งที่สมัคร
                  {{ applicant_apply_data.application_total }} ครั้ง
                </v-chip>
                <v-chip
                  outlined
                  class="my-4 my-sm-0 ml-sm-3"
                  color="default_chip_primary"
                >
                  จำนวนงานที่ถูกสมัคร
                  {{ applicant_apply_data.job_applied_total }} งาน
                </v-chip>
              </v-col>
              <v-col
                cols="12"
                sm="auto"
                v-if="$route.name == 'bookingManage' && applicant_apply_data"
                style="text-align: center"
                align-self="center"
              >
                <!-- change theme -->
                <v-chip
                  outlined
                  class="my-4 my-sm-0 ml-sm-3"
                  color="default_chip_primary"
                >
                  {{ $t("mbp.peopleBook") }}
                  {{ applicant_apply_data.applicant_total }}
                  {{ $t("extra.people") }}
                </v-chip>
                <v-chip
                  outlined
                  class="my-4 my-sm-0 ml-sm-3"
                  color="default_chip_primary"
                >
                  {{ $t("mbp.booked") }}
                  {{ applicant_apply_data.application_total }}
                  {{ $t("extra.times") }}
                </v-chip>
              </v-col>
              <v-spacer></v-spacer>
              <v-col
                :class="
                  $route.name == 'businessprofile' && use_trust_mode == 'false'
                    ? ''
                    : 'py-sm-4'
                "
                align-self="center"
              >
                <div v-if="use_trust_mode == 'true'">
                  ความน่าเชื่อถือ:
                  {{ text_trust_level(business_profile[0].trust_level) }}
                  <v-row no-gutters class="justify-center justify-sm-start">
                    <v-col
                      v-for="n in 3"
                      :key="n"
                      cols="auto"
                      class="pr-2"
                      align-self="center"
                    >
                      <v-card
                        :color="
                          n - 1 <= business_profile[0].trust_level
                            ? color_trust_level(business_profile[0].trust_level)
                            : '#CCCCCC'
                        "
                        elevation="0"
                        dark
                        :height="$vuetify.breakpoint.mdAndUp ? '15' : '10'"
                        :width="$vuetify.breakpoint.mdAndUp ? '75' : '45'"
                        style="border-radius: 8px"
                      >
                      </v-card>
                    </v-col>
                    <v-col cols="auto" align-self="center">
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="#184966" dark v-bind="attrs" v-on="on">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div class="work-page" style="min-width: 150px">
                          <v-row
                            no-gutters
                            class="text-tooltip"
                            v-for="(item, n) in biz_id_meaning"
                            :key="n"
                          >
                            <v-col cols="auto">
                              <div style="width: 60px">
                                {{ text_trust_level(n) }}:
                              </div>
                            </v-col>
                            <v-col cols="auto" class="pr-2">
                              <span>{{ item.name }}:</span>
                            </v-col>
                            <v-col>
                              <span v-html="item.detail"></span>
                            </v-col>
                          </v-row>
                        </div>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="auto"
                :class="
                  $route.name == 'businessprofile' && use_trust_mode == 'false'
                    ? ''
                    : 'py-sm-4'
                "
                style="text-align: center"
                align-self="center"
              >
                <v-btn
                  v-if="
                    $route.name == 'businessprofile' &&
                    business_profile[0].trust_level < 2 &&
                    use_trust_mode == 'true'
                  "
                  outlined
                  elevation="0"
                  class="my-4 my-sm-0 ml-sm-3"
                  width="190px"
                  color="#184966"
                  @click="clickedToAddTrustLevel"
                >
                  เพิ่มความเชื่อถือธุรกิจ
                </v-btn>
                <!-- change theme -->
                <v-btn
                  v-if="$route.name == 'Work'"
                  dark
                  elevation="0"
                  class="mt-3 mt-sm-0 ml-sm-3"
                  color="default_button_primary"
                  :width="$vuetify.breakpoint.smAndUp ? '190px' : ''"
                  @click="routeToCreatePage"
                >
                  <v-icon>mdi-plus</v-icon>
                  รับสมัครงาน
                </v-btn>
                <v-btn
                  v-if="$route.name == 'bookingManage'"
                  dark
                  elevation="0"
                  class="mt-3 mt-sm-0 ml-sm-3"
                  color="default_button_primary"
                  :width="$vuetify.breakpoint.smAndUp ? '190px' : ''"
                  @click="routeToCreateBookingPage"
                >
                  <v-icon>mdi-plus</v-icon>
                  {{ theme === 'TCC_EDUCATION_ADMIN' ? $t("mbp.btn.creatFund") : $t("mbp.btn.creat") }}
                </v-btn>
                <v-tooltip v-if="$route.name == 'Work'" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      elevation="0"
                      class="mt-3 mt-sm-0 ml-3"
                      color="#184966"
                      v-bind="attrs"
                      v-on="on"
                      @click="updateJobDate"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <div class="work-page text-center">
                    <span style="font-size: 16px">อัปเดตวันรับสมัครงาน</span>
                    <br />(เฉพาะสถานะเปิดรับเท่านั้น)
                  </div>
                </v-tooltip>
                <v-tooltip v-if="$route.name == 'bookingManage'" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      elevation="0"
                      class="mt-3 mt-sm-0 ml-3"
                      color="#184966"
                      v-bind="attrs"
                      v-on="on"
                      @click="updateJobDate"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <div class="work-page text-center">
                    <span style="font-size: 16px">{{ $t("mbp.updated") }}</span>
                  </div>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SelectBusinessHeaderComponent",
  data() {
    return {
      theme: process.env.VUE_APP_USE_THEME,
      tabMenu: 0,
      tab_status: "1,2",
      account_model: 1,
      search: "",
      tab_list: [
        {
          text: "บัญชีนิติบุคคล",
          value: "1,2",
          count: 0,
          business_account_model: 1,
        },
        {
          text: "บัญชีธุรกิจ (ร้านค้า)",
          value: "3",
          count: 0,
          business_account_model: 2,
        },
      ],
      account_id: localStorage.getItem("id_user") || null,
      business_id: localStorage.getItem("business_id") || null,
      show_trust_level: null,
      use_trust_mode: process.env.VUE_APP_USE_TRUST_USER_LEVEL,
      applicant_apply_data: null,
    };
  },
  async mounted() {
    let roleUser = localStorage.getItem("role");
    if (roleUser == "1") {
      this.$router.push("/manage_user");
    } else if (roleUser == "2") {
      this.$router.push("/dashboard");
    } else {
      if (
        !localStorage.getItem("business_id") ||
        !localStorage.getItem("position_role")
      ) {
        this.$router.push("/home");
      } else {
        // await this.getListData()
        await this.changeBusiness();
      }
    }
  },
  computed: {
    ...mapGetters({
      business_data_list: "business_data_list",
      business_total_list: "business_total_list",
      business_profile: "business_profile",
      user: "user",
      biz_id_meaning: "biz_id_meaning",
    }),
    listDataTotal() {
      let all_total = [];
      if (this.business_total_list) {
        // all_total[0] =
        //   parseInt(this.business_total_list.government_total) +
        //   parseInt(this.business_total_list.private_total);
        // all_total[1] = parseInt(this.business_total_list.commercial_total);
        all_total[0] = parseInt(this.business_total_list.business_total || 0);
        all_total[1] = parseInt(
          this.business_total_list.other_business_total || 0
        );
      }
      return all_total;
    },
    business_data_list_to_select() {
      let listdata = [];
      if (this.business_data_list.data) {
        let data_list = this.business_data_list.data;
        listdata = data_list.filter(function (value) {
          return value.business_sector != null && value.business_sector != "";
        });
      }
      return listdata;
    },
  },
  watch: {
    business_profile(val) {
      // if (val[0].business_sector == "1" || val[0].business_sector == "2") {
      if (val[0].business_account_model == "1") {
        this.tabMenu = 0;
        this.tab_status = "1,2";
        this.account_model = 1;
        this.show_trust_level = 0;
        // this.getListData()
      } else {
        this.tabMenu = 1;
        this.tab_status = "3";
        this.account_model = 2;
        this.show_trust_level = 1;
        // this.getListData()
      }
    },
    // business_id(val, oldVal){
    //   if (val != oldVal) {
    //     this.setPositionRole()
    //   }
    // },
  },
  created() {
    this.getTotaljob();
  },
  methods: {
    getTotaljob() {
      this.axios
        .get(`${process.env.VUE_APP_BACKEND}/api/v1/business_recruitment`, {
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            business_id: this.business_id,
          },
        })
        .then((response) => {
          this.applicant_apply_data = response.data.data_total_application;
        });
    },
    routeToCreatePage() {
      this.$store.commit("setDefaultData");
      this.$router.push("/work/create").catch((err) => {
        console.error("[routeToCreatePage] navigation failed:", err);
      });
    },
    routeToCreateBookingPage() {
      this.$store.commit("setDefaultData");
      this.$router.push("/manage_booking/create");
    },
    async getListData() {
      // this.$store.commit("onLoading");
      await this.$store
        .dispatch("getBusinessToSelect", {
          // account_id: this.account_id,
          // business_sector: this.tab_status,
          business_account_model: this.account_model,
          search: this.search,
        })
        .catch((err) =>
          this.$store.commit("onAlerting", {
            message_status: err.message,
            color: "#D1392B",
          })
        );
      // .finally(() => setTimeout(() => this.$store.commit("offLoading"), 600));
    },
    setStatusShow(data, index, model) {
      this.tab_status = data;
      this.tabMenu = index;
      this.account_model = model;
      this.getListData();
    },
    changeBusiness() {
      this.$store.commit("setBusiness_Id", this.business_id);
      this.$store.commit("onLoading");
      if (this.$route.name == "businessprofile") {
        this.$store
          .dispatch("getBusinessProfile")
          .then(() => {
            this.setPositionRole();
          })
          .finally(() =>
            setTimeout(() => this.$store.commit("offLoading"), 600)
          );
      } else if (
        this.$route.name == "Work" ||
        this.$route.name == "bookingManage"
      ) {
        this.$store.dispatch("getBusinessProfile").then(() => {
          this.setPositionRole();
        });
        this.$store
          .dispatch("getRecruitmentToTableByStatus", {
            business_id: this.business_id,
            page: 1,
            limit_per_page: 10,
          })
          .catch((err) =>
            this.$store.commit("onAlerting", {
              message_status: err.message,
              color: "#D1392B",
            })
          )
          .finally(() =>
            setTimeout(() => this.$store.commit("offLoading"), 600)
          );
      }
    },
    setPositionRole() {
      // let listdata = this.business_data_list.data
      // var position_role = listdata.find(el => el.business_id == this.business_id);
      // let position = position_role.position
      let position = this.business_profile[0].position;
      this.$store.commit("position_role", position);
    },
    async clickedToAddTrustLevel() {
      // await this.$store.dispatch("redirectToEditBusiness");
      // window.open(`${process.env.VUE_APP_REDIRECT_TO_BUSINESS_ONE}/business/${this.business_id}/edit`, "_blank");
      await this.$store.dispatch("shareTokenTo");
      const oneAccessToken = localStorage.getItem("sharetoken");
      window.open(
        `${process.env.VUE_APP_REDIRECT_TO_BUSINESS_ONE}/redirect-share-token?share_token=${oneAccessToken}`,
        "_blank"
      );
    },
    countItemInTab(val) {
      val[0].count = this.listDataTotal[0];
      val[1].count = this.listDataTotal[1];
      return this.tab_list;
    },
    async updateJobDate() {
      this.$store.commit("onLoading");
      await this.$store
        .dispatch("updateJobDate")
        .then(() => {
          window.location.reload();
        })
        .catch((err) =>
          this.$store.commit("onAlerting", {
            message_status: err.message,
            color: "#D1392B",
          })
        )
        .finally(() => setTimeout(() => this.$store.commit("offLoading"), 600));
    },
    color_trust_level(n) {
      if (n == 1) {
        return "#1E88E5";
      } else if (n == 2) {
        return "#58A144";
      } else {
        return "#FB8C00";
      }
    },
    text_trust_level(n) {
      if (n == 1) {
        return "ปานกลาง";
      } else if (n == 2) {
        return "มาก";
      } else {
        return "น้อย";
      }
    },
  },
};
</script>

<style scoped>
.work-page {
  font-family: Noto Sans Thai !important;
}
.title-text {
  font-size: 20px;
  font-weight: 700;
  color: #333333;
}
.customtab.v-tab {
  width: 250px;
}
.text-tooltip {
  font-weight: 500;
  font-size: 14px;
  font-family: Noto Sans Thai !important;
}
</style>